<cerrix-loader [cerrixTab]="tab"></cerrix-loader>

@if (categories && permissions) {
    <div class="form-screen-system" menuSystem [cerrixTab]="tab">
        <div
            class="form-screens"
            [attr.name]="'formHome.formsMenu' | t"
            menuicon="fas fa-file-alt"
            menuItemId="home"
            menusystemsubmenu
        >
            <div
                [attr.name]="'formHome.formOverviewMenu' | t"
                menuicon="fas fa-home"
                menuItemId="menuItemFormOverview"
                menusystemitem
            >
                <form-overview
                    [cerrixTab]="tab"
                    [categories]="categories"
                    [permissions]="permissions"
                ></form-overview>
            </div>
            <div
                [attr.name]="'formHome.invitedStatusOverviewMenu' | t"
                menuicon="fas fa-stream"
                menuItemId="invites"
                menusystemitem
            >
                <form-status [categories]="categories" [permissions]="permissions"></form-status>
            </div>
            @if (permissions.IsEditor || permissions.IsReleaser) {
                <div
                    [attr.name]="'formHome.formDraftsMenu' | t"
                    menuicon="fal fa-drafting-compass"
                    menuItemId="drafts"
                    menusystemitem
                >
                    <unreleased-form-overview></unreleased-form-overview>
                </div>
            }
        </div>
    </div>
}
